import React, { memo } from 'react';
import { RegisterMenuForm } from '../../organisms/menu/RegisterMenuForm';
import { useParams } from 'react-router-dom';
import { useRegisterKoreanMenuImages } from '../../../hooks/menu/useRegisterKoreanMenuImages';


export const KoreanDrinkMenuRegister: React.FC = memo(() => {
  const { restaurantId } = useParams()
  const onSubmit = useRegisterKoreanMenuImages('drink', restaurantId)
  return <RegisterMenuForm menuName='ドリンク' onSubmit={onSubmit} />;
});